import apiClient from './apiClient';

/**
 * GET /api/organisation/dashboard-summary?date=YYYY-MM-DD
 *
 * One round-trip that bundles every dataset the org dashboard loads on mount:
 *   { date, visits, consultation_stats, daily_summary, doctors,
 *     sittings: { assigned, delegated_by_me, action_pending } }
 *
 * Sections the caller isn't permitted to see (or that errored server-side)
 * come back as null. Used by services/dashboardHydrator.js to hydrate the
 * visit + sitting stores from a single request instead of ~8 separate calls.
 *
 * Returns the raw response body. Throws on transport/HTTP error — the
 * hydrator catches and falls back to per-widget fetches.
 */
export const fetchDashboardSummary = async (date) => {
  const params = {};
  if (date) params.date = date;
  const r = await apiClient.get('/api/organisation/dashboard-summary', { params });
  return r.data;
};
